import { ObjectReference } from '@totem/types/common';

export type { ObjectReference };

export interface EventCategory {
  id: string;
  name: string;
  description: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export type EventCategories = EventCategory[];

export interface TicketConfiguration {
  create: boolean;
  impact: string;
  urgency: string;
  category: string;
  subCategory: string;
}

export interface EventMatch {
  sourceSystem: string;
  sourceType: string;
  eventType: string;
  descriptionContains: string;
}

export interface CustomerInfo {
  whatItMeans: string;
  whyTicketRaised: string;
  impact: string;
}

export interface Cause {
  sequence: number;
  message: string;
}

export interface Action {
  sequence: number;
  message: string;
}

export interface TechnicianInfo {
  likelyCauses: Cause[];
  actions: Action[];
}

export interface HierarchyReference {
  organization: ObjectReference;
  region: ObjectReference;
  building: ObjectReference;
  controlSystem: ObjectReference;
}

export interface EventConfigurationItem {
  id: string;
  category: string;
  hierarchy: HierarchyReference;
  status: string;
  // Mirrors the synced rule's execution order (rules for the same domain/
  // trigger run in ascending sequence order). Existing EVENT-domain rules
  // conventionally use 100.
  sequence: number;
  ticketConfiguration: TicketConfiguration;
  eventMatches: EventMatch[];
  example: string;
  customerInfo: CustomerInfo;
  technicianInfo: TechnicianInfo;
  // Keys this item's action claims when it fires successfully — a later
  // rule/configuration item whose Claim Keys overlap gets skipped. See
  // rule-engine-library models.RuleActionDAO.ClaimKeys.
  claimKeys: string[];
  // Keys claimed-as-cancelled in the rules engine's claim map once this
  // item's action fires successfully — lets it suppress other rules/
  // configuration items that share a claim key. See rule-engine-library
  // models.RuleActionDAO.CancelsKeys.
  cancelsKeys: string[];
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export type EventConfigurationItems = EventConfigurationItem[];

export const IMPACT_URGENCY_OPTIONS = ['High', 'Medium', 'Low'];

export const STATUS_OPTIONS = ['Active', 'Inactive'];

// Mirrors mongo-client-library's utilities.EMPTY_ID — the sentinel used
// platform-wide for "no reference selected".
export const EMPTY_OBJECT_ID = '000000000000000000000000';

export const EMPTY_OBJECT_REFERENCE: ObjectReference = {
  id: EMPTY_OBJECT_ID,
  name: '',
};

export const EMPTY_HIERARCHY: HierarchyReference = {
  organization: { ...EMPTY_OBJECT_REFERENCE },
  region: { ...EMPTY_OBJECT_REFERENCE },
  building: { ...EMPTY_OBJECT_REFERENCE },
  controlSystem: { ...EMPTY_OBJECT_REFERENCE },
};
